import DynamicTitle from "./DynamicTitle.vue";
export default DynamicTitle;
